export default __webpack_public_path__ + "static/media/openstack.cdb2cf5c.svg";